/**
 * Розділи меню модуля, розгорнутість яких прототип v4 не зберігає: «Налаштування», «Проєктування» й розділи типів записів скидаються до
 * типових щоразу, коли модуль відкривають (openModule: navCollapsed без ключів /_(settings|records)$|^rt_|^md_/), і після перезавантаження
 * сторінки. Між відкриттями вибір користувача для них живе в пам'яті вкладки (menuSessionSlot, menuSession). Чиста функція.
 */
export function isTransientMenuId(id: string): boolean {
  return id === 'settings' || id === 'design' || id.startsWith('type:');
}
